(function () {
  var root = document.querySelector('[data-hdk-root]');
  if (!root) return;

  var form = root.querySelector('[data-hdk-form]');
  var byoWrap = root.querySelector('[data-hdk-byo]');
  var errorEl = root.querySelector('[data-hdk-error]');
  var submitBtn = root.querySelector('[data-hdk-submit]');
  var klaviyoEl = root.querySelector('[data-hdk-klaviyo]');
  var klaviyoCfg = { publicKey: '', listId: '', phone: '07 5500 0095' };

  try {
    if (klaviyoEl) klaviyoCfg = JSON.parse(klaviyoEl.textContent);
  } catch (e) {
    /* keep defaults */
  }

  function setRadio(name, value) {
    var input = form && form.querySelector('input[name="' + name + '"][value="' + value + '"]');
    if (input) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function scrollToForm() {
    var target = root.querySelector('#hdk-enquire');
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function syncByo() {
    if (!form || !byoWrap) return;
    var intent = form.querySelector('input[name="inquiry_type"]:checked');
    var isByo = intent && intent.value === 'byo_truck';
    byoWrap.hidden = !isByo;
    byoWrap.querySelectorAll('input, select').forEach(function (el) {
      if (el.name === 'truck_colour' || el.name === 'vehicle_year' || el.name === 'vehicle_model') {
        el.required = isByo;
      }
    });
  }

  root.querySelectorAll('.hdk-path[data-hdk-intent]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-hdk-intent');
      root.querySelectorAll('.hdk-path[data-hdk-intent]').forEach(function (el) {
        el.classList.toggle('is-selected', el === btn);
      });
      setRadio('inquiry_type', value);
      scrollToForm();
    });
  });

  root.querySelectorAll('.hdk-hero [data-hdk-intent]').forEach(function (link) {
    link.addEventListener('click', function () {
      setRadio('inquiry_type', link.getAttribute('data-hdk-intent'));
    });
  });

  root.querySelectorAll('[data-hdk-colour]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-hdk-colour');
      root.querySelectorAll('[data-hdk-colour]').forEach(function (el) {
        el.classList.toggle('is-selected', el === btn);
      });
      setRadio('kit_colour', value);
      scrollToForm();
    });
  });

  root.querySelectorAll('[data-hdk-suspension]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var value = btn.getAttribute('data-hdk-suspension');
      root.querySelectorAll('[data-hdk-suspension]').forEach(function (el) {
        el.classList.toggle('is-selected', el === btn);
      });
      setRadio('suspension_preference', value);
      scrollToForm();
    });
  });

  if (form) {
    form.querySelectorAll('input[name="inquiry_type"]').forEach(function (el) {
      el.addEventListener('change', syncByo);
    });
    syncByo();
  }

  var subnavLinks = root.querySelectorAll('[data-hdk-subnav] a');
  if ('IntersectionObserver' in window && subnavLinks.length) {
    var sections = [];
    subnavLinks.forEach(function (link) {
      var id = (link.getAttribute('href') || '').replace('#', '');
      var section = id && document.getElementById(id);
      if (section) sections.push(section);
    });
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          subnavLinks.forEach(function (link) {
            link.classList.toggle('is-active', link.getAttribute('href') === '#' + entry.target.id);
          });
        });
      },
      { rootMargin: '-40% 0px -50% 0px', threshold: 0 }
    );
    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  var heroVideo = root.querySelector('.hdk-hero__video');
  if (heroVideo && 'IntersectionObserver' in window) {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) {
      heroVideo.pause();
    } else {
      var videoObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var play = heroVideo.play();
              if (play && play.catch) play.catch(function () {});
            } else {
              heroVideo.pause();
            }
          });
        },
        { threshold: 0.15 }
      );
      videoObserver.observe(heroVideo);
    }
  }

  var lightboxRoot = root.querySelector('[data-hdk-lightbox-root]');
  var lightboxItems = Array.prototype.slice.call(root.querySelectorAll('[data-hdk-lightbox]'));
  var lightboxImg = root.querySelector('[data-hdk-lightbox-img]');
  var lightboxCaption = root.querySelector('[data-hdk-lightbox-caption]');
  var lightboxIndex = 0;

  function showLightbox(index) {
    if (!lightboxRoot || !lightboxItems.length) return;
    lightboxIndex = (index + lightboxItems.length) % lightboxItems.length;
    var item = lightboxItems[lightboxIndex];
    lightboxImg.src = item.getAttribute('data-hdk-src');
    lightboxImg.alt = item.getAttribute('data-hdk-alt') || '';
    lightboxCaption.textContent = item.getAttribute('data-hdk-alt') || '';
    lightboxRoot.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function hideLightbox() {
    if (!lightboxRoot) return;
    lightboxRoot.hidden = true;
    document.body.style.overflow = '';
  }

  lightboxItems.forEach(function (item, index) {
    item.addEventListener('click', function () {
      showLightbox(index);
    });
  });

  if (lightboxRoot) {
    var closeBtn = lightboxRoot.querySelector('[data-hdk-lightbox-close]');
    var prevBtn = lightboxRoot.querySelector('[data-hdk-lightbox-prev]');
    var nextBtn = lightboxRoot.querySelector('[data-hdk-lightbox-next]');
    if (closeBtn) closeBtn.addEventListener('click', hideLightbox);
    if (prevBtn) prevBtn.addEventListener('click', function () { showLightbox(lightboxIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showLightbox(lightboxIndex + 1); });
    lightboxRoot.addEventListener('click', function (e) {
      if (e.target === lightboxRoot) hideLightbox();
    });
    document.addEventListener('keydown', function (e) {
      if (lightboxRoot.hidden) return;
      if (e.key === 'Escape') hideLightbox();
      if (e.key === 'ArrowLeft') showLightbox(lightboxIndex - 1);
      if (e.key === 'ArrowRight') showLightbox(lightboxIndex + 1);
    });
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (errorEl) errorEl.hidden = true;
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    if (!klaviyoCfg.publicKey || !klaviyoCfg.listId || String(klaviyoCfg.publicKey).indexOf('YOUR_') === 0) {
      if (errorEl) {
        errorEl.hidden = false;
        errorEl.textContent = 'Enquiry form is not configured yet. Call us on ' + (klaviyoCfg.phone || '07 5500 0095') + '.';
      }
      return;
    }

    var data = new FormData(form);
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting…';

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: data.get('form_source') || 'Harley Super Duty Kit',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: data.get('email'),
                first_name: (data.get('full_name') || '').split(' ')[0] || '',
                last_name: (data.get('full_name') || '').split(' ').slice(1).join(' ') || '',
                phone_number: data.get('phone'),
                properties: {
                  Form_Source: data.get('form_source') || 'Harley Super Duty Kit',
                  Inquiry_Type: data.get('inquiry_type') || '',
                  Kit_Colour: data.get('kit_colour') || '',
                  Truck_Colour: data.get('truck_colour') || '',
                  Vehicle_Year: data.get('vehicle_year') || '',
                  Vehicle_Model: data.get('vehicle_model') || '',
                  Suspension_Preference: data.get('suspension_preference') || '',
                  Preferred_Workshop: data.get('preferred_workshop') || '',
                  Questions_Comments: data.get('questions_comments') || '',
                  Page_URL: window.location.href,
                },
              },
            },
          },
        },
        relationships: {
          list: { data: { type: 'list', id: klaviyoCfg.listId } },
        },
      },
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + klaviyoCfg.publicKey, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2023-12-15',
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        if (res.status === 202 || res.status === 200 || res.status === 204) {
          var intent = data.get('inquiry_type') === 'supply_truck' ? 'supplying a Super Duty' : 'fitting the Harley kit to your truck';
          form.innerHTML =
            '<div class="hdk-form__success">' +
            '<h2>Thank you</h2>' +
            '<p>Your enquiry about <strong>' +
            escapeHtml(intent) +
            '</strong> is in. The Tough Trucks team will be in touch shortly.</p>' +
            '</div>';
        } else {
          throw new Error(String(res.status));
        }
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Send enquiry';
        if (errorEl) {
          errorEl.hidden = false;
          errorEl.textContent =
            'There was an error submitting the form. Please try again or call us on ' +
            (klaviyoCfg.phone || '07 5500 0095') +
            '.';
        }
      });
  });
})();
